import moment from "moment"
import Button from "../../../components/Button"

const RequestPointItem = (props) => {
  const detailHandler = () => {
    const data = {
      worker_id: props.worker_id,
      worker_name: props.worker_name
    }
    props.setDataDetail(data)
    props.setModal(true)
  }

  return (
    <tr>
      <td className="text-center">{props.no}</td>
      <td className="text-center">
        <p className="m-0">{props.worker_id} | {props.worker_name}</p>
        <Button
          iconRight="fa fa-chevron-right ms-2 fs-10"
          title="Mutasi Poin"
          button="text-primary fw-bold p-0"
          onClick={detailHandler}
        />
      </td>
      <td className="text-center">
        {(props.type === 'reward') ? (
          <p className="m-0 fw-semibold" style={{color: '#FF8B04'}}>Penukaran Barang</p>
        ) : (
          <p className="m-0 fw-semibold" style={{color: '#0D9734'}}>Pencairan Uang</p>
        )}
      </td>
      <td className="text-center">{props.nominal.toLocaleString()}</td>
      <td className="text-center">{moment(props.date).format('DD/MM/YYYY HH:mm:ss')}</td>
      <td className="text-center">
        {(['Diproses', 'Selesai', 'Disetujui']).includes(props.status) ? (
          <>
            <p className="m-0 fw-semibold" 
              style={{color: props.status === 'Disetujui' ? '#10BD41' : props.status === 'Diproses' ? '#FF8B04' : '#197463'}}>
              {props.status}
            </p>
            <p className="m-0">{props.approve_by && props.approve_by+' | '}{moment(props.approve_at).format('DD/MM/YYYY HH:mm:ss')}</p>
          </>
        ) : (
          <p className="m-0 fw-semibold">{props.status}</p>
        )}
      </td>
    </tr>
  )
}

export default RequestPointItem
